module.exports = __webpack_public_path__ + "static/media/10.a84d1fe8.jpg";